var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.089,
    height: 17.43,
    viewBox: "0 0 16.089 17.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    "data-name": "Path 3840",
    d: "M-345.251-308.659h-2.682v-.67a.671.671,0,0,0-.67-.67h0a.671.671,0,0,0-.67.67v.67h-5.363v-.67a.671.671,0,0,0-.67-.67h0a.671.671,0,0,0-.67.67v.67h-2.682A1.34,1.34,0,0,0-360-307.318v13.408a1.34,1.34,0,0,0,1.341,1.341h13.408a1.34,1.34,0,0,0,1.341-1.341v-13.408A1.34,1.34,0,0,0-345.251-308.659Zm0,14.749h-13.408V-303.3h13.408Zm0-10.726h-13.408v-2.682h2.682v.67a.671.671,0,0,0,.67.67h0a.671.671,0,0,0,.67-.67v-.67h5.363v.67a.671.671,0,0,0,.67.67h0a.671.671,0,0,0,.67-.67v-.67h2.682Z",
    transform: "translate(360 310)",
    fill: "#4a4a4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5f8519297760bfcf673f8522d6012412.svg";
export { ForwardRef as ReactComponent };